<div
  [ngClass]="{
    department: true,
    closed: isCollapsed,
    empty: structuralUnit.childUnitsCount === 0
  }">
  <div class="toggle" aria-controls="collapse">
    <div
      class="toggle-left"
      [attr.aria-expanded]="!isCollapsed"
      (click)="isCollapsed = !isCollapsed"
      (keydown.enter)="isCollapsed = !isCollapsed"
      tabindex="1">
      @if (structuralUnit.childUnitsCount && structuralUnit.childUnitsCount > 0) {
        <img [ngClass]="{ chevron: true, open: !isCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
      }
      <h5
        [ngClass]="{
          'group-title': true,
          empty: structuralUnit.childUnitsCount === 0
        }">
        {{ structuralUnit.name }} ({{ structuralUnit.code }})
      </h5>
    </div>
    <div class="actions">
      <app-edit-structural-unit
        [isParent]="true"
        [structuralUnit]="structuralUnit"
        [isLoading]="isCrudLoading"
        [policyType]="CLAIM_SCOPE"
        [claimType]="CLAIM_TYPES['update']"
        (save)="updateStructuralUnit($event)"
        appPermission />
    </div>
  </div>
  <div id="collapseExample" [ngbCollapse]="isCollapsed">
    @for (item of structuralUnit.childUnits; track item) {
      <div class="item-wrapper">
        <div class="item">
          <p class="item-name">{{ item.name }} ({{ item.code }})</p>
          <div class="item-actions">
            <app-edit-structural-unit
              [structuralUnit]="item"
              [isLoading]="isCrudLoading"
              [policyType]="CLAIM_SCOPE"
              [claimType]="CLAIM_TYPES['update']"
              (save)="updateStructuralUnit($event)"
              appPermission />
          </div>
        </div>
      </div>
    }
  </div>
</div>
